// extracted by mini-css-extract-plugin
module.exports = {"Landing":"body_Landing__V1o9I","Head":"body_Head__ZNO0s","MainInfo":"body_MainInfo__vxeu_","Services":"body_Services__9mWgt","Left":"body_Left__hYGVU"};